
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SpeechLanguageSelectorProps {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
  disabled?: boolean;
}

// Currently only supporting English (US) for reliable speech recognition
// Chinese option archived due to inconsistent recognition quality
const SPEECH_LANGUAGES = [
  { code: 'en-US', name: 'English (US)', nameEn: 'English (US)', flag: '🇺🇸' },
];

// Archived Chinese option for future use:
// { code: 'zh-CN', name: '中文 (简体)', nameEn: 'Chinese (Simplified)', flag: '🇨🇳' },

export const SpeechLanguageSelector: React.FC<SpeechLanguageSelectorProps> = ({
  selectedLanguage,
  onLanguageChange,
  disabled = false
}) => {
  const { t, i18n } = useTranslation('recording');

  return (
    <div className="space-y-2">
      <Label htmlFor="speech-language-select" className="flex items-center gap-2 text-sm font-medium">
        <Languages className="h-4 w-4" />
        {t('languageSelector.label')}
      </Label>
      <Select
        value={selectedLanguage}
        onValueChange={onLanguageChange}
        disabled={disabled}
      >
        <SelectTrigger id="speech-language-select" className="w-full">
          <SelectValue placeholder={t('languageSelector.placeholder')} />
        </SelectTrigger>
        <SelectContent>
          {SPEECH_LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <div className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.nameEn}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
